import { Component, OnInit , AfterViewInit , Input} from '@angular/core';

@Component({
  selector: 'app-small-guide',
  templateUrl: './small-guide.component.html',
  styleUrls: ['./small-guide.component.css']
})
export class SmallGuideComponent implements OnInit , AfterViewInit{
  @Input() content:string;


  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit(){

  }

}



// WEBPACK FOOTER //
// ./src/app/small-guide/small-guide.component.ts